import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { withSiteMap, getRoutePathById } from '@bingads-webui-react/with-site-map';
import { Link, Text } from '@fluentui/react-components';
import { MessageBar, MessageBarTitle, MessageBarBody } from '@fluentui/react-message-bar';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { ScopeLevel } from '@bingads-webui-campaign-react/constants';
import { PermissionsContext } from '@bingads-webui-react/hoc-with-permissions';
import { getStyles } from './styles/site-exclusion-note-style';

const SiteExclusionNoteBase = ({ level, siteMap }) => {
  const i18n = useContext(I18nContext);
  const path = getRoutePathById(siteMap, 'site-exclusion-lists-entrypoint');
  const classes = useDefaultStyles(getStyles);
  const { dynamic: { AWFWebExclusionsWarning: showAWFWarning } } = useContext(PermissionsContext);

  return (
    <div className="site-exclusion-note">
      <MessageBar layout="multiline">
        <MessageBarBody>
          <MessageBarTitle>{i18n.getString(_TL_('Note'))}</MessageBarTitle>
          {level === ScopeLevel.AdGroup ? (
            <Text size={200}>{showAWFWarning ? i18n.getString(_TL_('Add websites to exclude at the ad group level below. Any account-level website exclusion lists will also be applied to this ad group. Please note that Audience campaigns will always serve on Microsoft sites (e.g., Microsoft Bing, Microsoft Casual Games, MSN, and Outlook.com) even if you\'ve added website exclusions for them.')) : i18n.getString(_TL_('Add websites to exclude at the ad group level below. Any account-level website exclusion lists will also be applied to this ad group.'))}</Text>
          ) : (
            <Text size={200}>{showAWFWarning ? i18n.getString(_TL_('Add websites to exclude at the campaign level below. Any account-level website exclusion lists will also be applied to this campaign. Please note that Audience campaigns will always serve on Microsoft sites (e.g., Microsoft Bing, Microsoft Casual Games, MSN, and Outlook.com) even if you\'ve added website exclusions for them.')) : i18n.getString(_TL_('Add websites to exclude at the campaign level below. Any account-level website exclusion lists will also be applied to this campaign.'))}</Text>
          )}
          {path && (
            <span className={classes.link}>
              <Link href={path} target="_blank" rel="noopener noreferrer">
                <span>
                  <u>{i18n.getString(_TL_('View account-level website exclusion lists'))}</u>
                </span>
              </Link>
            </span>
          )}
        </MessageBarBody>
      </MessageBar>
    </div>
  );
};

SiteExclusionNoteBase.propTypes = {
  level: PropTypes.string.isRequired,
  siteMap: PropTypes.shape({}).isRequired,
};

export const SiteExclusionNote = withSiteMap(SiteExclusionNoteBase);
